// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2YX02","textarea":"styles_textarea__3Ylqt"};